export const LOAN_PURPOSES = {
  debt_consolidation: {
    activeIconURL: '/assets/images/loan-purpose-debt-consolidation-active.svg',
    iconURL: '/assets/images/loan-purpose-debt-consolidation.svg',
    label: 'Debt Consolidation',
    value: 'debt_consolidation',
  },
  monthly_bills: {
    activeIconURL: '/assets/images/loan-purpose-monthly-bills-active.svg',
    iconURL: '/assets/images/loan-purpose-monthly-bills.svg',
    label: 'Monthly Bills',
    value: 'monthly_bills',
  },
  moving: {
    activeIconURL: '/assets/images/loan-purpose-moving-active.svg',
    iconURL: '/assets/images/loan-purpose-moving.svg',
    label: 'Moving',
    value: 'moving',
  },
  other: {
    activeIconURL: '/assets/images/loan-purpose-other-active.svg',
    iconURL: '/assets/images/loan-purpose-other.svg',
    label: 'Other',
    value: 'other',
  },
};

export type LoanPurposeValueT = keyof typeof LOAN_PURPOSES;
export type LoanPurposeLabelT = typeof LOAN_PURPOSES[LoanPurposeValueT]['label'];
export type LoanPurposeTypeT = {
  activeIconURL: string;
  iconURL: string;
  label: LoanPurposeLabelT;
  value: LoanPurposeValueT;
};

export const loanPurposeOptions: LoanPurposeTypeT[] = Object
  .values(LOAN_PURPOSES) as LoanPurposeTypeT[];

export type NcBorrowingNeedsFormT = {
  loanAmount: number;
  loanPurpose: LoanPurposeValueT;
};
